(() => {
  const header = document.querySelector('.site-header');
  const menuToggle = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.primary-nav');
  const slides = [...document.querySelectorAll('.hero-slide')];
  const dots = [...document.querySelectorAll('.dot')];
  const prev = document.querySelector('.slide-arrow.prev');
  const next = document.querySelector('.slide-arrow.next');
  let current = 0;
  let timer;

  const setHeader = () => header.classList.toggle('scrolled', window.scrollY > 12);
  window.addEventListener('scroll', setHeader, { passive: true });
  setHeader();

  if (menuToggle && nav) menuToggle.addEventListener('click', () => {
    const open = nav.classList.toggle('open');
    menuToggle.setAttribute('aria-expanded', String(open));
  });
  if (nav) nav.querySelectorAll('a, button').forEach(link => link.addEventListener('click', () => {
    nav.classList.remove('open');
    menuToggle.setAttribute('aria-expanded', 'false');
  }));

  const showSlide = (index) => {
    current = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => slide.classList.toggle('active', i === current));
    dots.forEach((dot, i) => {
      const active = i === current;
      dot.classList.toggle('active', active);
      dot.setAttribute('aria-selected', String(active));
    });
  };
  const startTimer = () => {
    clearInterval(timer);
    timer = setInterval(() => showSlide(current + 1), 6500);
  };
  if (prev) prev.addEventListener('click', () => { showSlide(current - 1); startTimer(); });
  if (next) next.addEventListener('click', () => { showSlide(current + 1); startTimer(); });
  dots.forEach((dot, i) => dot.addEventListener('click', () => { showSlide(i); startTimer(); }));
  startTimer();

  const filterButtons = document.querySelectorAll('.filter-btn');
  const cards = document.querySelectorAll('.project-card');
  filterButtons.forEach(button => button.addEventListener('click', () => {
    filterButtons.forEach(btn => btn.classList.remove('active'));
    button.classList.add('active');
    const filter = button.dataset.filter;
    cards.forEach(card => card.classList.toggle('is-hidden', filter !== 'all' && card.dataset.category !== filter));
  }));

  const lightbox = document.querySelector('.lightbox');
  const lightboxImage = lightbox ? lightbox.querySelector('img') : null;
  const closeLightbox = () => {
    if (!lightbox || !lightboxImage) return;
    lightbox.hidden = true;
    lightboxImage.src = '';
    document.body.style.overflow = '';
  };
  document.querySelectorAll('.gallery-item').forEach(item => item.addEventListener('click', () => {
    if (!lightbox || !lightboxImage) return;
    lightboxImage.src = item.dataset.full;
    lightboxImage.alt = item.querySelector('img').alt;
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
  }));
  if (lightbox) lightbox.querySelector('.lightbox-close').addEventListener('click', closeLightbox);
  if (lightbox) lightbox.addEventListener('click', event => { if (event.target === lightbox) closeLightbox(); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && lightbox && !lightbox.hidden) closeLightbox(); });

  const loadProfileData = (scriptUrl) => {
    if (window.TrustEngineeringProfileBase64) return Promise.resolve();
    if (window.TrustEngineeringProfileLoading) return window.TrustEngineeringProfileLoading;

    window.TrustEngineeringProfileLoading = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = scriptUrl;
      script.async = true;
      script.onload = () => window.TrustEngineeringProfileBase64 ? resolve() : reject(new Error('Profile data was not loaded.'));
      script.onerror = () => reject(new Error('Profile download data could not be loaded.'));
      document.head.appendChild(script);
    });

    return window.TrustEngineeringProfileLoading;
  };

  const profileBlobFromBase64 = (base64) => {
    const binary = atob(base64);
    const chunkSize = 1024 * 512;
    const chunks = [];
    for (let offset = 0; offset < binary.length; offset += chunkSize) {
      const slice = binary.slice(offset, offset + chunkSize);
      const bytes = new Uint8Array(slice.length);
      for (let i = 0; i < slice.length; i += 1) bytes[i] = slice.charCodeAt(i);
      chunks.push(bytes);
    }
    return new Blob(chunks, { type: 'application/pdf' });
  };

  document.querySelectorAll('[data-profile-download]').forEach(button => button.addEventListener('click', async () => {
    if (button.classList.contains('is-downloading')) return;

    const originalText = button.textContent;
    button.classList.add('is-downloading');
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Preparing download…';

    try {
      await loadProfileData(button.dataset.profileScript);
      const blob = profileBlobFromBase64(window.TrustEngineeringProfileBase64);
      const objectUrl = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = objectUrl;
      anchor.download = 'Trust-Engineering-Company-Profile.pdf';
      anchor.style.display = 'none';
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      setTimeout(() => URL.revokeObjectURL(objectUrl), 15000);
    } catch (error) {
      console.error(error);
      window.alert('The company profile could not be downloaded. Please try again.');
    } finally {
      button.classList.remove('is-downloading');
      button.removeAttribute('aria-busy');
      button.textContent = originalText;
    }
  }));

  const year = document.getElementById('year');
  if (year) year.textContent = new Date().getFullYear();
})();
